import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getexternalAuditHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "externalaudit", ...action.payload }),
		);
		yield put({
			type: types.GET_EXTERNAL_AUDIT_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_EXTERNAL_AUDIT_ERROR,
			payload,
		});
	}
}

export function* getexternalAuditWatcherSaga() {
	yield takeLatest(types.GET_EXTERNAL_AUDIT_START, getexternalAuditHandlerSaga);
}

//create

//delete

function* deleteexternalAuditHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("externalaudit", action.payload),
		);
		yield put({
			type: types.DELETE_EXTERNAL_AUDIT_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_EXTERNAL_AUDIT_ERROR,
			payload,
		});
	}
}

export function* deleteexternalAuditWatcherSaga() {
	yield takeLatest(
		types.DELETE_EXTERNAL_AUDIT_START,
		deleteexternalAuditHandlerSaga,
	);
}

//update
